import {
  Dialog,
  DialogBody,
  DialogContent,
  IconButton,
  Sheet,
  SheetBody,
  SheetContent,
  Typography,
} from "@suraasa/placebo-ui"
import { theme, useMediaQuery } from "@suraasa/placebo-ui-legacy"
import { Xmark } from "iconoir-react"
import { useEffect, useState } from "react"
import Lottie from "react-lottie"

interface Props {
  open: boolean
  handleClose: () => void
  courseName: string
}

const CourseCompletion = ({ open, handleClose, courseName }: Props) => {
  const isXsDown = useMediaQuery(theme.breakpoints.down("xs"))
  return isXsDown ? (
    <Sheet open={open} onOpenChange={handleClose}>
      <SheetContent
        height={55}
        className="bg-gradient-to-b from-[#FFFFFF] via-[#FFFFFF_10%] to-[#A3E8CD]"
        closeWhenInteractOutside
      >
        <SheetBody>
          <CourseCompletionContent
            handleClose={handleClose}
            courseName={courseName}
          />
        </SheetBody>
      </SheetContent>
    </Sheet>
  ) : (
    <Dialog open={open} onOpenChange={handleClose} modal>
      <DialogContent
        closeWhenInteractOutside
        className="bg-gradient-to-b from-[#FFFFFF] via-[#FFFFFF_10%] to-[#A3E8CD]"
      >
        <DialogBody>
          <CourseCompletionContent
            handleClose={handleClose}
            courseName={courseName}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

const CourseCompletionContent = ({
  handleClose,
  courseName,
}: {
  handleClose: () => void
  courseName: string
}) => {
  const [confetti, setConfetti] = useState<object | null>(null)

  useEffect(() => {
    import("assets/Course/confetti.json").then(mod => setConfetti(mod.default))
  }, [])

  return (
    <div>
      <div className="absolute inset-0 -z-1 !cursor-default overflow-hidden">
        {confetti && (
          // @ts-expect-error react version issues
          <Lottie
            isClickToPauseDisabled
            style={{
              cursor: "default",
            }}
            options={{
              loop: true,
              autoplay: true,
              animationData: confetti,
            }}
          />
        )}
      </div>
      <div className="mb-2 flex justify-end">
        <IconButton onClick={handleClose} color="black">
          <Xmark />
        </IconButton>
      </div>

      <div className="mx-5 mb-10 flex flex-col items-center">
        <Typography
          variant="title1"
          className="mb-1.5 text-success-600"
          style={{ fontFamily: "Nicholas-Bold" }}
        >
          Course Finished!
        </Typography>
        <Typography className="mb-3.5 text-center text-success-900">
          {`You have successfully finished ${courseName}!`}
        </Typography>

        <Typography
          variant="subtitle2"
          className="text-center text-success-900"
        >
          We&apos;re calculating your final GPA to determine your certificate
          eligibility. Sit tight — we&apos;ll notify you if you&apos;re
          eligible!
        </Typography>
      </div>
    </div>
  )
}

export default CourseCompletion
